// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sKi3S","suffix":"_2gEi3","title-wrapper":"_7pJhT","titleWrapper":"_7pJhT"};